import type { IValidatedResponse } from '../../httpClient';
import { getRequest } from '../../httpClient';
import type { ISearchWikiquotePagesV1Response } from './search-wikiquote-pages-v1-response';
import { searchWikiquotePagesV1ResponseSchema } from './search-wikiquote-pages-v1-response';

export async function searchWikiquotePagesV1Api(
  query: string,
): Promise<IValidatedResponse<ISearchWikiquotePagesV1Response>> {
  const params = new URLSearchParams({ query });
  return getRequest<ISearchWikiquotePagesV1Response>({
    path: `/sys/quotes/v1/search?${params.toString()}`,
    schema: searchWikiquotePagesV1ResponseSchema,
  });
}
